import axios from 'axios'
import { initComponents } from './componentHelpers'

export function initModalLinks (siteWrapper, modalWrapper, APP) {
  const modalLinks = [...siteWrapper.querySelectorAll('.js-Modal__link')]
  modalLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      let href = link.href

      document.documentElement.classList.add('_is_requesting')
      axios.get(href + '?ajax=1')
        .then((res) => {
          modalWrapper.innerHTML = res.data.content
          initComponents(modalWrapper, APP)
          window.history.pushState({}, '', href)
          document.documentElement.classList.remove('_is_requesting')
        })
      return false
    })
  })
}

export function initAnchorLinks (siteWrapper) {
  const anchorLinks = [...siteWrapper.querySelectorAll('a[href*="#"]')]
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      let anchor = siteWrapper.querySelector(link.hash)
      if (anchor) {
        anchor.scrollIntoView()
        return false
      } else {
        return true
      }
    })
  })
}
